import formActionTypes from 'constants/formConstants';
import every from 'lodash/every';

const ensurePrimaryLinkPresent = (state, action) => {
  if (action.meta.field !== 'links' || state.values.links.length === 0) {
    return state;
  }

  if (every(state.values.links, { 'is_primary': false })) {
    const { index } = action.meta;
    const newIndex = index === state.values.links.length ? index - 1 : index;
    state.values.links[newIndex].is_primary = true;
  }

  return state;
};

export default function formHooks(state, action) {
  switch (action.type) {
    case formActionTypes.ON_ARRAY_REMOVE:
      return ensurePrimaryLinkPresent(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/formHooksReducer.js